import React from 'react'
import { Typography, Box, FormControl, FormGroup, FormControlLabel, Checkbox, FormHelperText } from '@mui/material'
import { PrioritiesStepProps } from '../types'

const PrioritiesStep: React.FC<PrioritiesStepProps> = ({ selected, onChange, error }) => {
  const options = [
    'Price',
    'Distance to campus',
    'Furnished units',
    'Roommates / Community',
    'Amenities (gym, study rooms, etc.)',
    'Lease flexibility',
  ]

  const handleChange = (option: string, checked: boolean) => {
    if (checked) {
      // Only allow adding if less than 3 items are selected
      if (selected.length < 3) {
        onChange([...selected, option])
      }
    } else {
      onChange(selected.filter(item => item !== option))
    }
  }

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        What matters most to you when choosing housing? (Pick up to 3)
      </Typography>

      <FormControl error={error}>
        <FormGroup className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel
              key={opt}
              control={
                <Checkbox
                  checked={selected.includes(opt)}
                  onChange={e => handleChange(opt, e.target.checked)}
                  disabled={!selected.includes(opt) && selected.length >= 3}
                />
              }
              label={opt}
              className="text-base"
            />
          ))}
        </FormGroup>
        {error && <FormHelperText>Please select at least one priority</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default PrioritiesStep
